// src/services/alertService.js
import Swal from 'sweetalert2';
import { submitActivity } from './activityService';

const showAlert = (title, icon) => {
  return Swal.fire({
    position: 'center',
    icon,
    title,
    showConfirmButton: false,
    timer: 1500,
  });
};

const showAjaxAlert = (title, data) => {
    return Swal.fire({
        title,
        input: "number",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async (peso) => {
          data.peso = peso;
          try {
            const response = await submitActivity(data);
            if (!response.ok) {
              return Swal.showValidationMessage(`
                ${JSON.stringify(await response.json())}
              `);
            }
            return response.json();
          } catch (error) {
            Swal.showValidationMessage(`
              Request failed: ${error}
            `);
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire({
                position: 'center',
                icon: "success",
                title: `Peso guardado con exito!`,
                showConfirmButton: false,
                timer: 1500,
            });
        }
      });
    };

const showSuccessAlert = (title, text) => {
  return showAlert(title, 'success');
};

const showErrorAlert = (title, text) => {
  return showAlert(title, 'error');
};

const showWarningAlert = (title, text) => {
  return showAlert(title, 'warning');
};

export { showSuccessAlert, showErrorAlert, showWarningAlert, showAjaxAlert };
